<div class="row mb-3">
  <div class="col text-center">
    <h2 class="zero-text p-huge-bold">
      {{ 'customer-promotion.headline' | transloco }}
    </h2>
  </div>
</div>

<div class="row same-height font-medium">
  <div class="col border text-center m-3 p-3">
    <div class="d-flex justify-content-center align-items-center mb-4">
      <div class="circle-filled mr-2">1</div>
      <div class="font-bold">{{ 'customer-promotion.1.header' | transloco }}</div>
    </div>
    <div class="text-size-large">{{ 'customer-promotion.1.text' | transloco }}</div>
  </div>
  <div class="col border text-center m-3 p-3">
    <div class="d-flex justify-content-center align-items-center mb-4">
      <div class="circle-filled mr-2">2</div>
      <div class="font-bold">{{ 'customer-promotion.2.header' | transloco }}</div>
    </div>
    <div class="text-size-large">
      {{ 'customer-promotion.2.text' | transloco }}
    </div>
  </div>
  <div class="col border text-center m-3 p-3">
    <div class="d-flex justify-content-center align-items-center mb-4">
      <div class="circle-filled mr-2">3</div>
      <div class="font-bold">{{ 'customer-promotion.3.header' | transloco }}</div>
    </div>
    <div class="text-size-large">
      {{ bonus ?? 'customer-promotion.3.text' | transloco }}
    </div>
  </div>
</div>

<div class="row--secondary mt-3">
  <div class="col d-flex justify-content-center">
    @if (loggedIn && !showPromoCode) {
      <web-design-system-button class="full-width-on-small-devices" (click)="showPromoCode = true">
        {{ 'customer-promotion.button.logged-in' | transloco }}
      </web-design-system-button>
    }
    @if (!loggedIn) {
      <web-design-system-button [routerLink]="commonRoutes.postlogin.wincustomer">
        {{ 'customer-promotion.button.logged-out' | transloco }}
      </web-design-system-button>
    }
    @if (notYetCustomerMessage) {
      <div class="mt-2 text-color-basic">
        <p>{{ 'customer-promotion.potential-customer' | transloco }}</p>
      </div>
    }
    @if (promoLink && showPromoCode) {
      <div class="mt-1">
        <div>
          <h5 class="mb-1">{{ 'customer-promotion.promo.header' | transloco }}</h5>
          <web-design-system-copy-to-clipboard
            [label]="promoLink"
            iconCssClass="icon-dark"
            [hint]="'customer-promotion.promo.copy-to-clipboard' | transloco"
          />
        </div>
        <p class="mt-3">
          Deinen persönlichen Einladungslink findest Du auch jederzeit im
          <a [routerLink]="commonRoutes.postlogin.verwaltung" class="link-underline">Verwaltungsbereich</a>
          unter Kunden werben Kunden.
        </p>
      </div>
    }
  </div>
</div>

<div class="row mt-4">
  <div class="col text-center">
    Lies hier die genauen
    <a
      class="link-secondary text-default"
      href="https://www.finanzen.net/zero/kunden-werben-kunden"
      target="_blank"
      rel="noopener noreferrer"
      >Teilnahmebedingungen</a
    >.
  </div>
</div>
